import { GoogleLogin } from '@react-oauth/google';
import { C, ALLOWED_DOMAIN } from '../config';
export function LoginScreen({ onSuccess, onError, authError }) {
  return (
    <div style={{ minHeight:'100vh', background:C.bg, display:'flex', alignItems:'center',
      justifyContent:'center', flexDirection:'column', gap:16, fontFamily:"'IBM Plex Mono',monospace" }}>
      <div style={{ fontSize:28, fontWeight:700, color:C.text }}>Sleep Metrics</div>
      <div style={{ fontSize:14, color:C.muted, marginBottom:8 }}>Command Center</div>
      {authError && <div style={{ fontSize:13, color:C.red, background:C.surface,
        border:'1px solid '+C.border, borderRadius:8, padding:'10px 18px', maxWidth:340, textAlign:'center' }}>{authError}</div>}
      <GoogleLogin onSuccess={onSuccess} onError={onError} theme="filled_blue" size="large" text="signin_with" shape="rectangular" useOneTap={false} auto_select={false} />
      <div style={{ fontSize:12, color:C.muted, marginTop:4 }}>{ALLOWED_DOMAIN} accounts only</div>
    </div>
  );
}
